import { KpiCard } from '@evi/ui';
import type { OperatorDashboardData } from '@evi/shared';
import { formatCountDelta } from './_lib';

export default function KpiSessions({ summary }: { summary: OperatorDashboardData | undefined }) {
  return (
    <KpiCard
      label="Active sessions"
      value={summary ? String(summary.activeSessions.value) : '—'}
      unit={summary ? `/${summary.activeSessions.ofTotal}` : undefined}
      delta={summary ? formatCountDelta(summary.activeSessions.deltaCount) : undefined}
    />
  );
}
